import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { JobAssignment } from '../../../shared/api';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { jobsFragments } from 'src/admin-app/jobs/jobs.routes';
import { buildListMessage } from 'src/admin-app/utilities/list-filtering/list-message';

@Component({
	selector: 'rpfsa-job-assignments-list',
	templateUrl: './job-assignments-list.component.html',
})
export class JobAssignmentsListComponent implements AfterViewInit {
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@Input() set jobAssignments(assignments: JobAssignment[]) {
		if (assignments) {
			this.dataSource.data = assignments;
		}
		this.message = buildListMessage(null, this.loading, {
			pageNumber: 0,
			results: assignments,
			resultCount: assignments ? assignments.length : 0,
		});
	}

	emptyColumns = ['empty'];
	resultColumns = ['job', 'start', 'end', 'shifts'];
	dataSource = new MatTableDataSource<JobAssignment>([]);
	jobsFragments = jobsFragments;
	message: string;

	get loading(): boolean {
		return this.dataSource.data === undefined;
	}

	ngAfterViewInit() {
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginator;
	}
}
